<template>
  <div v-if="isReady" class="wrapper" id="bar-scroll-wrapper">
    <div class="control-area">
      <div>
        <div class="scroll-controls center-vertical">
          <div class="scroll-controls-headings"></div>
          <div class="left-total text-center"><strong>%</strong></div>
          <div class="left-total text-center"><strong>hrs</strong></div>
        </div>
      </div>

      <div class="scroll-controls">
        <div class="scroll-controls-headings text-right">
          <div v-for="staff in staffList" v-bind:key="staff.bwf_userid"
               class="scroll-control-heading center-vertical">
            {{ staff.name }}
          </div>
          <div class="text-left"><strong>Labour Total</strong></div>
        </div>

        <div class="text-right scroll-controls-controls">
          <div v-for="(staff, idx)  in staffList" v-bind:key="staff.bwf_userid"
               class="scroll-controls-control center-vertical">
            <ScrollControl v-model="staffAllocations[staff.bwf_userid]" :max="100" :step="2"
                           :color="getColor(idx)" @input="changed" ref="scrollControlRef"
                           :disabled="!$access.permissions.includes('Modify Capacity Plan')"/>
            <div class="estimate-hours">
              {{ staffAllocations[staff.bwf_userid].hours }}
            </div>
          </div>
          <div class="total">
            <div class="left-total" :class="{'overage':total>100}">
              {{ total }}%
            </div>

            <div class="estimate-hours" :class="{'overage':total>100}">
              {{ estimateTotalHours() }} / {{ estimatedHours }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ScrollControl from "@/components/toolkit/ScrollControl.vue"
import {defineComponent} from "vue"
import {getStaffList} from "@/lib/lookup";
import {colors} from "@/lib/constants";


export default defineComponent({
  name: "BarScrollStaff",
  components: {
    ScrollControl,
  },
  props: ["value", "jobId", "jobPlannedCapacityData"],
  permissions: [],
  computed: {
    estimatedHours: function () {
      let total = 0
      for (const dateData of Object.values(this.jobPlannedCapacityData)) {
        for (const serviceData of Object.values(dateData)) {
          total += serviceData || 0
        }
      }
      return total
    },
    total: function () {
      let total = 0
      this.staffList.forEach((staff) => {
        if (this.staffAllocations[staff.bwf_userid]) {
          total += this.staffAllocations[staff.bwf_userid].planned || 0
        }
      })
      return total
    },

  },
  methods: {
    getColor(idx) {
      return colors[idx % colors.length]
    },
    changed() {
      // recalculate hours based on percentage
      this.staffList.forEach((staff) => {
        if (this.staffAllocations[staff.bwf_userid]) {
          const allocation = this.staffAllocations[staff.bwf_userid]
          this.staffAllocations[staff.bwf_userid].hours = Math.round((allocation.planned / 100) * this.estimatedHours)
        }
      })
      this.$emit("changed", this.staffAllocations)
    },
    estimateTotalHours() {
      let total = 0
      this.staffList.forEach((staff) => {
        if (this.staffAllocations[staff.bwf_userid]) {
          total += this.staffAllocations[staff.bwf_userid].hours
        }
      })
      return total
    },
  },
  mounted() {
    this.staffAllocations = this.value || {} // alias for staffAllocations

    getStaffList(this, (staff) => {
      this.staffList = staff
      this.staffList.forEach((staff) => {
        if (!this.staffAllocations[staff.bwf_userid]) {
          this.$set(this.staffAllocations, staff.bwf_userid, {planned: 0, hours:0})
        }
      })
      this.changed()
      this.isReady = true
    })
  },
  data() {
    return {
      isReady: false,
      totals: {},
      job: null,
      staffList: [],
    }
  }
})

</script>

<style scoped>
.scroll-controls {
  padding-left: 25px;
  display: inline-block;
  vertical-align: top;
}

.scroll-controls-headings {
  display: inline-block;
  margin-top: 5px;
  margin-right: 5px;
  background: white;
  width: 175px;
  vertical-align: top;
}

.scroll-controls-controls {
  display: inline-block;
  margin-top: 5px;
  background: white;
  vertical-align: top;
}

.wrapper {
  overflow-x: auto;
  white-space: nowrap;
  position: relative;
}

.center-vertical {
  display: flex;
  align-items: center;
  height: 52px;
}

.total {
  font-weight: bold;
  text-align: center;
}

.estimate-hours {
  margin-left: 15px;
  display: inline-block;
}

.left-total {
  width: 50px;
  display: inline-block;
}

.overage {
  color: red;
}
</style>